import React, { useEffect, useRef, useState } from 'react'

function NewsCompony() {
  return (
    <div className='c-News-Compony'>
        <div className='News-Compony' style={{flexDirection: "row-reverse"}}>
            <div className='about-C-item handleWidthItem newsTextFa' style={{direction: "rtl"}}>
            <p className='title-about'>  اخبار و مقالات </p>
            <div className='textJustify'> در این بخش جدیدترین اخبار و مقالات مرتبط با صنعت سنگ و آهن را دنبال کنید. اطلاعات به‌روز در مورد نوسانات بازار، فناوری‌های نوین، و روندهای مهم در این صنایع ارائه می‌شود </div>
                <div className='btn-abotu'>  ادامه </div>
            </div>
            <div className='about-C-item handleWidthItem'> 
               <Slider />
            </div>
        </div>
    </div>
  )
}

export default NewsCompony

const images  = [
    {
        ID: 1 ,
        src:"image/News-ahan.jpg",
        title: "تلاش‌های صنعت آهن برای کاهش کربن ",
        discription: "صنایع جهانی آهن و فولاد در حال گذار به سمت کاهش انتشار کربن هستند تا با توافق‌نامه آب‌وهوایی پاریس سازگار شوند",
    },
    {
        ID: 2 ,
        src:"image/News-sang.jpg",
        title: " پایداری در صنعت سنگ ",
        discription: " در بخش سنگ، تقاضا برای منابع پایدار و روش‌های تولید دوست‌دار محیط‌زیست در حال افزایش است",
    },
    {
        ID: 3 ,
        src:"image/News-ahan-1.jpg",
        title: " فصل طلایی خرید آهن فرا رسید ",
        discription: "قیمت آهن آلات در روز یکشنبه با کاهش قابل توجهی مواجه شد و به نظر می‌رسد بازار در مسیر اصلاح قرار گرفته است",
    },
    // {
    //     ID: 4 ,
    //     src:"image/cat-2-4.jpg",
    //     title: "لورم ایپسوم متنی ساختگی  4",
    //     discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 4",
    // },
    // {
    //     ID: 5 ,
    //     src:"image/cat-2-5.jpg",
    //     title: "لورم ایپسوم متنی ساختگی  5",
    //     discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 5",
    // },
    // {
    //     ID: 6 ,
    //     src:"image/cat-2-6.jpg",
    //     title: "لورم ایپسوم متنی ساختگی  6",
    //     discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 6",
    // },
    // {
    //     ID: 7 ,
    //     src:"image/cat-2-7.jpg",
    //     title: "لورم ایپسوم متنی ساختگی  7",
    //     discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 7",
    // },
    // {
    //     ID: 8 ,
    //     src:"image/cat-2-8.jpg",
    //     title: "لورم ایپسوم متنی ساختگی  8",
    //     discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 8",
    // },
  ];

// function Slider(){
//     const [currentSlide, setCurrentSlide] = useState(0);
//     const sliderRef = useRef(null);
//     const slides = [...images , ...images , ...images]

//     const calculateSlideWidth = () => {
//         const slide = sliderRef.current.children[0];
//         const slideWidth = slide.offsetWidth;
//         const gap = parseFloat(window.getComputedStyle(slide).marginRight);
        
//         return slideWidth + gap;
//     };

//     const slideNext = () => {
//         if (currentSlide < images.length - 1) {
//             setCurrentSlide(currentSlide + 1);
//         } else {

//             setCurrentSlide(0); // بازگشت به اولین اسلاید
//         }
//     };

//     const slidePrev = () => {
//         if (currentSlide > 0) {
//             setCurrentSlide(currentSlide - 1);
//         } else {
//             setCurrentSlide(images.length - 1); // حرکت به آخرین اسلاید
//         }
//     };

//     useEffect(() => {
//         const interval = setInterval(() => {
//             slideNext();
//         }, 5000); // هر 5 ثانیه

//         return () => clearInterval(interval); // تمیزکاری
//     }, [currentSlide]);

//     useEffect(() => {
//         const offset = -calculateSlideWidth() * currentSlide;
//         sliderRef.current.style.transform = `translateX(${offset}px)`;
//     }, [currentSlide]);

//     useEffect(() => {
//         const handleResize = () => {
//             const offset = -calculateSlideWidth() * currentSlide;
//             sliderRef.current.style.transform = `translateX(${offset}px)`;
//         };
//         window.addEventListener('resize', handleResize);

//         return () => {
//             window.removeEventListener('resize', handleResize);
//         };
//     }, [currentSlide]);

//     return (
//       <div className="slider-container">
//       <div className="slider"  ref={sliderRef}>
//         {slides.map((item , index) => (
//           <div key={index} className="slide">
//             <img src={item.src} alt=""/>
//             <div className='c-textimageSlider'></div>
//             <div className='textimageSlider'>
//                     <h3>{item.title}</h3>
//                     <p> {item.discription} </p>
//                 </div>
//           </div>
//         ))}
//       </div>
//       <button className="prev" onClick={slidePrev}>&#10094;</button>
//       <button className="next" onClick={slideNext}>&#10095;</button>
//     </div>
//     );
// };

// function Slider() {
//     const [currentSlide, setCurrentSlide] = useState(0);
//     const sliderRef = useRef(null);
//     const slides = [...images, ...images, ...images];
  
//     let startX = 0;
//     let endX = 0;
  
//     const calculateSlideWidth = () => {
//         const slide = sliderRef.current.children[0];
//         const slideWidth = slide.offsetWidth;
//         const gap = parseFloat(window.getComputedStyle(slide).marginRight);
  
//         return slideWidth + gap;
//     };
  
//     const slideNext = () => {
//         if (currentSlide < images.length - 1) {
//             setCurrentSlide(currentSlide + 1);
//         } else {
//             setCurrentSlide(0); // بازگشت به اولین اسلاید
//         }
//     };
  
//     const slidePrev = () => {
//         if (currentSlide > 0) {
//             setCurrentSlide(currentSlide - 1);
//         } else {
//             setCurrentSlide(images.length - 1); // حرکت به آخرین اسلاید
//         }
//     };
  
//     // مدیریت حرکت انگشت برای اسلاید
//     const handleTouchStart = (e) => {
//         console.log("handleTouchStart" , e.touches[0].clientX);
        
//         startX = e.touches[0].clientX;
//     };
  
//     const handleTouchMove = (e) => {
//         console.log("handleTouchMove" , e.touches[0].clientX);

//         endX = e.touches[0].clientX;
//     };
  
//     const handleTouchEnd = () => {
//         console.log("handleTouchEnd");


//         const swipeDistance = startX - endX;
//         if (swipeDistance > 50) {
//             // سوایپ به چپ: به اسلاید بعدی برو
//             slideNext();
//         } else if (swipeDistance < -50) {
//             // سوایپ به راست: به اسلاید قبلی برو
//             slidePrev();
//         }
//     };
  
//     // useEffect(() => {
//     //     const interval = setInterval(() => {
//     //         slideNext();
//     //     }, 5000); // هر 5 ثانیه
  
//     //     return () => clearInterval(interval); // تمیزکاری
//     // }, [currentSlide]);
  
//     useEffect(() => {
//         const offset = -calculateSlideWidth() * currentSlide;
//         sliderRef.current.style.transform = `translateX(${offset}px)`;
//     }, [currentSlide]);
  
//     useEffect(() => {
//         const handleResize = () => {
//             const offset = -calculateSlideWidth() * currentSlide;
//             sliderRef.current.style.transform = `translateX(${offset}px)`;
//         };
//         window.addEventListener('resize', handleResize);
  
//         return () => {
//             window.removeEventListener('resize', handleResize);
//         };
//     }, [currentSlide]);
  
//     return (
//         <div className="slider-container"
//              onTouchStart={handleTouchStart}
//              onTouchMove={handleTouchMove}
//              onTouchEnd={handleTouchEnd}>
//             <div className="slider" ref={sliderRef}>
//                 {slides.map((item, index) => (
//                     <div key={index} className="slide">
//                         <img src={item.src} alt="" />
//                         <div className='c-textimageSlider'></div>
//                         <div className='textimageSlider'>
//                             <h3>{item.title}</h3>
//                             <p>{item.discription}</p>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//             <button className="prev" onClick={slidePrev}>&#10094;</button>
//             <button className="next" onClick={slideNext}>&#10095;</button>
//         </div>
//     );
// }
  
function Slider() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);
    const slides = [...images];

    let startX = 0;
    let endX = 0;
    let isSwiping = false; // برای تشخیص سوایپ واقعی

    const calculateSlideWidth = () => {
        const slide = sliderRef.current.children[0];
        const slideWidth = slide.offsetWidth;
        const gap = parseFloat(window.getComputedStyle(slide).marginRight);
        return slideWidth + gap;
    };

    const slideNext = () => {
        if (currentSlide < images.length - 1) {
            setCurrentSlide(currentSlide + 1);
        } else {
            return
            setCurrentSlide(0); // بازگشت به اولین اسلاید
        }
    };

    const slidePrev = () => {
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        } else {
            return
            setCurrentSlide(images.length - 1); // حرکت به آخرین اسلاید
        }
    };

    // مدیریت حرکت انگشت برای اسلاید
    const handleTouchStart = (e) => {
        startX = e.touches[0].clientX;
        isSwiping = false; // هنگام شروع تاچ، فرض کنیم که هنوز سوایپ نشده است
    };

    const handleTouchMove = (e) => {
        endX = e.touches[0].clientX;
        const swipeDistance = startX - endX;

        // اگر فاصله بیشتر از 10 پیکسل باشد، سوایپ فعال می‌شود
        if (Math.abs(swipeDistance) > 10) {
            isSwiping = true; // سوایپ فعال است
        }
    };

    const handleTouchEnd = () => {
        if (!isSwiping) {
            // اگر سوایپ فعال نشده، یعنی کاربر فقط کلیک کرده و نیازی به تغییر اسلاید نیست
            return;
        }

        const swipeDistance = startX - endX;
        const threshold = 50; // میزان حداقل فاصله برای تشخیص سوایپ

        if (swipeDistance > threshold) {
            // سوایپ به چپ: به اسلاید بعدی برو
            slideNext();
        } else if (swipeDistance < -threshold) {
            // سوایپ به راست: به اسلاید قبلی برو
            slidePrev();
        }
    };

    useEffect(() => {
        const offset = -calculateSlideWidth() * currentSlide;
        sliderRef.current.style.transform = `translateX(${offset}px)`;
    }, [currentSlide]);

    useEffect(() => {
        const handleResize = () => {
            const offset = -calculateSlideWidth() * currentSlide;
            sliderRef.current.style.transform = `translateX(${offset}px)`;
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [currentSlide]);

    return (
        <div className="slider-container"
             onTouchStart={handleTouchStart}
             onTouchMove={handleTouchMove}
             onTouchEnd={handleTouchEnd}>
            <div className="slider" ref={sliderRef}>
                {slides.map((item, index) => (
                    <div key={index} className="slide">
                        <img src={item.src} alt="" />
                        <div className='c-textimageSlider'></div>
                        <div className='textimageSlider'>
                            <h3>{item.title}</h3>
                            <p>{item.discription}</p>
                        </div>
                    </div>
                ))}
            </div>
            <button className="prev" onClick={slidePrev}>&#10094;</button>
            <button className="next" onClick={slideNext}>&#10095;</button>
        </div>
    );
}

        

